module.exports = __webpack_public_path__ + "img/infinity-war.8773404.jpg";